export default "__VITE_ASSET__Bu47qKli__"